import { Box } from '@eatclubcode/ec-component-library';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { getAppConfig } from '../../constants/appConfig';
import { trackDetailedEvent } from '../../utils/analytics';
import { RoundButton } from '../button/RoundButton';
import UnpauseModal from '../UnpauseModal/UnpauseModal';
import useStyles from './DisabledBannerStyles';
import WarningIcon from '../../assets/icons/warning_drawn.svg';

const DisabledBanner = () => {
  const classes = useStyles();
  const appConfig = getAppConfig();
  const restaurantActive = useSelector((state) => state.restaurantActive.restaurant);

  const [showModal, setShowModal] = useState(false);

  const isDisabled = !restaurantActive?.enabled;
  const newVenue = restaurantActive?.isNew;

  /**
   * Venue could be disabled or pause for a number of reasons
   */
  const getMessage = () => {
    // Restaurant is new
    if (newVenue) {
      return `Your account is currently being set up. Call ${appConfig.supportPhone} if you need any
              support`;
    }

    // Restaurant de-activated
    if (isDisabled) {
      return (
        <Box>
          This account is currently disabled. Please contact support via{' '}
          <a href={`mailto:${appConfig.supportEmail2}`} target='_blank' rel='noreferrer'>
            {appConfig.supportEmail2}
          </a>{' '}
          if you wish to have the account re-enabled.
        </Box>
      );
    }

    // Restaurant paused
    return 'Your account has been paused. All offers have been disabled';
  };

  return (
    <>
      <Box className={classes.wrapper}>
        <Box className={classes.container}>
          <Box className={classes.contentContainer}>
            <WarningIcon style={{ flexShrink: 0 }} />
            <Box>{getMessage()}</Box>
          </Box>

          {!isDisabled && (
            <RoundButton
              variant='outlined'
              color='secondary'
              onClick={() => {
                trackDetailedEvent('Pause reactivation button clicked');
                setShowModal(true);
              }}
              style={{ button: { fontWeight: '400' }, text: { lineHeight: '20px' } }}
            >
              Re-activate
            </RoundButton>
          )}
        </Box>
      </Box>
      <UnpauseModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default DisabledBanner;
